
jQuery( ( $ ) => {

	// Fetched asynchronously without blocking below so the add-to-basket
	// enable/disable handlers are bound immediately on page load, not after
	// this request resolves.
	const translationsPromise = $.get( red61.ajax_url, { action: 'get_translations', component: 'productPage' } )
		.then( ( productTranslations ) => {
			window.translations = {
				...productTranslations.translations
			};
			return productTranslations.translations;
		} );

	$( '.merchandise-detail .merch-row select' ).change( function() {
		if ( 0 < this.value ) {
			$( this )
				.closest( '.merch-row' )
				.find( '.add-to-basket' )
				.removeClass( 'disabled-btn-state' )
				.prop( 'disabled', false );
		}
		else {
			$( this ).closest( '.merch-row' )
				.find( '.add-to-basket' )
				.addClass( 'disabled' )
				.prop( 'disabled', true );
		}

	} );

	$( '.merchandise-detail .add-to-basket' ).click( async function( event ) {
		event.preventDefault();
		const merchandiseRef = $( this ).closest( '.merch-variation-wrapper' ).find( 'input[name="merchandiseRef"]' ).val();
		const merchandiseRefCssClass = merchandiseRef.replace( ':', '-' );

		const response = await addToBasket( $( this ) );
		const translations = await translationsPromise;
		updateBasketMessage( response.message, merchandiseRefCssClass, translations );
		if ( response.basket ) {
			$( '.cart-btn .price' ).text( response.basket.total );
		}
		if ( 'alert-success' === response.message.className ) {
			$( this ).closest( '.merch-row' ).find( '.qty-select-merch' ).val( 0 );
			$( this ).addClass( 'disabled-btn-state' );

		}
	} );

	function updateBasketMessage( message, merchandiseRef, translations ) {
		const pageURL = `${window.location.href  }`;
		const pageURLwithPolyLang = pageURL.replace( 'merchandise', 'basket' );
		$( '.alert' ).empty();
		$( '.alert' ).removeClass( 'alert-success' );
		$( `.basket-message-${merchandiseRef}` ).text( message.text );
		if( 'alert-success' === message.className  ){
			const goToCheckout = _.template(
				'<%- translations[ "GO TO CHECKOUT" ] || "GO TO CHECKOUT" %>'
			);
			$( `.basket-message-${merchandiseRef}` ).append( `<a class="underline" href="${ pageURLwithPolyLang }">${ goToCheckout( translations ) }</a>` );
		}
		$( `.basket-message-${merchandiseRef}` ).attr( 'class', `alert ${message.className} basket-message-${merchandiseRef}` );
	}

	async function addToBasket( $button ) {
		$( '.basket-message' ).addClass( 'd-none' );
		$button.addClass( 'disabled-btn-state' );

		const formData = new FormData();
		formData.append( 'action', 'add_merchandise_to_basket' );
		formData.append( 'merchandiseRef',
			$button.closest( '.merch-row' ).find( 'input[name="merchandiseRef"]' ).val(),
		);
		formData.append( 'amount',
			$button.closest( '.merch-row' ).find( '.qty-select-merch' ).val(),
		);
		const response = await $.ajax( {
			method: 'post',
			processData: false,
			contentType: false,
			cache: false,
			data: formData,
			enctype: 'multipart/form-data',
			url: red61.ajax_url,
		} ).promise();

		$button.removeClass( 'disabled-btn-state' );
		return response;
	}

	// MOBILE

	$( '.merchandise-detail-mobile .merch-row select' ).change( function() {
		if ( 0 < this.value ) {
			$( this )
				.closest( '.merch-row' )
				.find( '.add-to-basket-mobile' )
				.removeClass( 'disabled-btn-state' )
				.prop( 'disabled', false );
		}
		else {
			$( this ).closest( '.merch-row' )
				.find( '.add-to-basket-mobile' )
				.addClass( 'disabled-btn-state' )
				.prop( 'disabled', true );
		}
	} );


	$( '.merchandise .add-to-basket-mobile' ).click( async function( event ) {
		event.preventDefault();
		const merchandiseRef = $( this ).closest( '.merch-variation-wrapper-mobile' ).find( 'input[name="merchandiseRef"]' ).val();
		const merchandiseRefCssClass = merchandiseRef.replace( ':', '-' );

		const response = await addToBasket( $( this ) );
		updateBasketMessageMobile( response.message, merchandiseRefCssClass );
		if ( response.basket ) {
			$( '.cart-btn .price' ).text( response.basket.total );
		}
		if ( 'alert-success' === response.message.className ) {
			$( this ).closest( '.merch-row' ).find( '.qty-select-merch' ).val( 0 );
			$( this ).addClass( 'disabled-btn-state' );
			$( '.merch-checkout-mobile' ).each( function(){
				if( !( $( this ).hasClass( 'display-none' ) ) ){
					$( this ).addClass( 'display-none' );
				}
			} );
			$( this ).closest( '.merch-row' ).find( '.merch-checkout-mobile' ).removeClass( 'display-none' );
		}
	} );

	function updateBasketMessageMobile( message, merchandiseRef ) {

		$( '.alert' ).empty();
		$( '.alert' ).removeClass( 'alert-success' );
		$( `.basket-message-${merchandiseRef}` ).text( message.text );
		$( `.basket-message-${merchandiseRef}` ).attr( 'class', `alert ${message.className} basket-message-${merchandiseRef}` );
	}

} );
